import {
  UNIT_STATUS_ACTIVE,
  UNIT_STATUS_CANCELLED,
  UNIT_STATUS_INACTIVE,
  UNIT_STATUS_PENDING_CANCELLATION
} from '@apps-common/config/unit-filter'
import { IManagementUnitSearchModel } from '@apps-common/types/management/unit'
import { IPortalUnitSearchModel, IUnitGenericDetailsModel } from '@apps-common/types/portal/unit'

// portal

export const unitIsCancelled = (unit?: IUnitGenericDetailsModel) =>
  unit !== undefined && (!!unit.dateDeleted || unit.status === UNIT_STATUS_CANCELLED.value)

export const unitIsInactive = (unit?: IUnitGenericDetailsModel) =>
  unit !== undefined && (!unit.isActivated || unit.status === UNIT_STATUS_INACTIVE.value)

export const unitIsActive = (unit?: IUnitGenericDetailsModel) =>
  unit !== undefined && unit.isActivated && unit.status === UNIT_STATUS_ACTIVE.value

// portal

export const unitIsCancelledPortal = (unit?: IPortalUnitSearchModel) =>
  unit !== undefined && (!!unit.cancellationDate || unit.status === UNIT_STATUS_CANCELLED.value)

export const unitIsInactivePortal = (unit?: IPortalUnitSearchModel) =>
  unit !== undefined && ((!unit.cancellationDate && !unit.isActivated) || unit.status === UNIT_STATUS_INACTIVE.value)

export const unitIsActivePortal = (unit?: IPortalUnitSearchModel) =>
  unit !== undefined && unit.isActivated && unit.status === UNIT_STATUS_ACTIVE.value

export const unitIsPendingCancellationPortal = (unit?: IPortalUnitSearchModel) =>
  unit !== undefined && unit.isActivated && unit.pendingCancellationDate && unit.status === UNIT_STATUS_PENDING_CANCELLATION.value

// management

export const unitIsCancelledManagement = (unit?: IManagementUnitSearchModel) =>
  unit !== undefined && (!!unit.cancellationDate || unit.status === UNIT_STATUS_CANCELLED.value)

export const unitIsInactiveManagement = (unit?: IManagementUnitSearchModel) =>
  unit !== undefined && ((!unit.cancellationDate && !unit.isActivated) || unit.status === UNIT_STATUS_INACTIVE.value)

export const unitIsActiveManagement = (unit?: IManagementUnitSearchModel) =>
  unit !== undefined && unit.isActivated && unit.status === UNIT_STATUS_ACTIVE.value

export const unitIsPendingCancellationManagement = (unit?: IManagementUnitSearchModel) =>
  unit !== undefined && unit.isActivated && unit.pendingCancellationDate && unit.status === UNIT_STATUS_PENDING_CANCELLATION.value

// unit account no

export const checkAccountNo = (accountNo?: string, status?: string): string => {
  if (!accountNo) {
    return 'None'
  }

  if (status === UNIT_STATUS_INACTIVE.value) {
    return 'TBC'
  }

  return accountNo
}
